import { formatFiatUnits } from '../amount/format-money.js';
import { exchangeAmountDecimal } from '../exchange/exchange-amount.js';
/** Source amounts are denominated in the asset actually withdrawn, never fiat. */
export function fundingSourcePresentation(operation, locale) {
    if ('cryptoDepositSource' in operation) {
        const source = operation.cryptoDepositSource;
        return source ? `${source.asset} · ${source.networkName}` : null;
    }
    if ('connectedWalletSource' in operation) {
        const source = operation.connectedWalletSource;
        return source ? `${source.asset} · ${source.network}` : null;
    }
    if (!('exchangeSource' in operation))
        return formatFiatUnits(operation.principalUnits, operation.fiatDecimals, operation.fiatCurrency, locale);
    const source = operation.exchangeSource;
    return source ? `${exchangeAmountDecimal(source.units, source.decimals)} ${source.asset}` : null;
}
